import React, { useEffect } from "react";
import "../css/ConfirmModal.css";

import crossIcon from "../assets/UserIcons/Cancel.svg";

const ConfirmModal = ({
  open,
  iconSrc,
  iconAlt = "Confirm",
  message,
  confirmText = "Continue",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  onClose,
  confirmDisabled = false,
  cancelDisabled = false,
  confirmButtonClassName = "custom-btn",
  cancelButtonClassName = "cancle-btn",
}) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") (onClose || onCancel)?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onCancel, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal modal-backdrop-custom d-block confirm-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) (onClose || onCancel)?.();
      }}
    >
      <div className="modal-dialog modal-dialog-centered w-50 confirm-modal-dialog">
        <div className="modal-content confirm-modal-content w-75">
          <button
            type="button"
            className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
            onClick={() => (onClose || onCancel)?.()}
            aria-label="Close"
          >
            <img src={crossIcon} className="icon-image cross-i" alt="Close" />
          </button>

          <div className="text-center p-3">
            {iconSrc && (
              <div className="confirm-modal-icon-wrap mx-auto mb-3 d-flex align-items-center justify-content-center">
                <img
                  src={iconSrc}
                  alt={iconAlt}
                  className="confirm-modal-icon"
                />
              </div>
            )}

            <p className="mt-3 mb-3 refresh-prompts confirm-modal-message">
              {message}
            </p>
          </div>

          <div className="modal-footer justify-content-center gap-2">
            <button
              type="button"
              className={`px-5 rounded border-none py-2 fw-bold ${cancelButtonClassName}`}
              onClick={() => onCancel?.()}
              disabled={cancelDisabled}
            >
              {cancelText}
            </button>

            <button
              type="button"
              className={`px-5 rounded border-none py-2 fw-bold ${confirmButtonClassName}`}
              onClick={() => onConfirm?.()}
              disabled={confirmDisabled}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
